import { List } from "immutable";

import clipboardActions from "../../constants/clipboardActions";
import nativeCommsMessageTypes from "../../nativeComms/nativeCommsMessageTypes";
import { filterReadonlyMenus } from "../../utils/codeSplit";
import { WINDOWS_KEY_LABEL_CONTROL as keyCtrl } from "./constants";
import readonlyEditMenus from "./readonlyMenuItems/readonlyEditMenus";
import toMenuItemRecord from "./toMenuItemRecord";
import { getShortCutString } from "./utils";

export default (state, disabledItems) => {
  return filterReadonlyMenus(
    readonlyEditMenus,
    List([
      {
        label: "Undo",
        messageType: nativeCommsMessageTypes.UNDO,
        shortcut: getShortCutString([keyCtrl, "Z"]),
        disabled: false
      },
      {
        label: "Redo",
        messageType: nativeCommsMessageTypes.REDO,
        shortcut: getShortCutString([keyCtrl, "Y"]),
        disabled: false,
        hasSeparator: true
      },
      {
        label: "Cut",
        messageType: clipboardActions.CUT,
        shortcut: getShortCutString([keyCtrl, "X"]),
        disabled: false
      },
      {
        label: "Copy",
        messageType: clipboardActions.COPY,
        shortcut: getShortCutString([keyCtrl, "C"]),
        disabled: false
      },
      {
        label: "Paste",
        messageType: clipboardActions.PASTE,
        shortcut: getShortCutString([keyCtrl, "V"]),
        disabled: false,
        hasSeparator: false
      },
      {
        label: "Select All",
        messageType: nativeCommsMessageTypes.SELECT_ALL,
        shortcut: getShortCutString([keyCtrl, "A"]),
        hasSeparator: true
      },
      {
        label: "Find...",
        messageType: nativeCommsMessageTypes.OPEN_SEARCH,
        shortcut: getShortCutString([keyCtrl, "F"]),
        disabled: false
      },
      {
        label: "Find and Replace...",
        messageType: nativeCommsMessageTypes.OPEN_SEARCH_AND_REPLACE,
        shortcut: getShortCutString([keyCtrl, "H"]),
        disabled: false
      }
    ])
  ).map(item => toMenuItemRecord(item, disabledItems));
};
